import React, { useEffect, useState } from 'react';
import './HomeHero.css';

//const HERO_IMAGE = 'https://images.unsplash.com/photo-1683701251422-912fe98f2b5e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0ZWNobm9sb2d5JTIwd29ya3NwYWNlfGVufDF8fHx8MTc2NDMzMDcwNHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral';

export function HomeHero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="home-hero">
      <div 
          className="home-hero-background"
          style={{
            transform: `translateY(${scrollY * 0.5}px)`
          }}
        >
          <video
            className="home-hero-video"
            src={`${process.env.PUBLIC_URL}/NY_Video.mp4`}  // <-- your video path here
            autoPlay
            loop
            muted
            playsInline
          />


          <div className="home-hero-overlay"></div>
          <div className="hero-glow-effect"></div>
      </div>

      
      <div className="home-hero-content">
        <div className="hero-badge-home fade-in">
          <span>Transform. Innovate. Succeed.</span>
        </div>
        <h1 className="home-hero-title fade-in" style={{ animationDelay: '0.2s' }}>
          Your Trusted Partner in<br />
          <span className="gradient-highlight">Digital Transformation</span>
        </h1>
        <p className="home-hero-subtitle fade-in" style={{ animationDelay: '0.4s' }}>
          SFrays delivers cutting-edge technology solutions and expert training to help businesses thrive in the digital age. From custom development to cloud solutions, we turn your vision into reality.
        </p>
        <div className="home-hero-actions fade-in" style={{ animationDelay: '0.6s' }}>
          <button className="btn btn-primary">Get Started</button>
          <button className="btn btn-secondary-home">Explore Solutions</button>
        </div>

        <div className="hero-features fade-in" style={{ animationDelay: '0.8s' }}>
          <div className="hero-feature-item">
            <div className="feature-icon">✓</div>
            <span>200+ Projects Delivered</span>
          </div>
          <div className="hero-feature-item">
            <div className="feature-icon">✓</div>
            <span>Expert Tech Team</span>
          </div>
          <div className="hero-feature-item">
            <div className="feature-icon">✓</div>
            <span>24/7 Support</span>
          </div>
        </div>
      </div>

      {/* Animated particles */}
      <div className="home-particles">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i} 
            className="home-particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
}
